
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the token in the headers
axiosInstance.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem('userToken');
  
    if (token) {
      config.headers["x-access-token"] = token; // Set the token in the header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export const saveContactUs = async (payload) => {
  try {
    const response = await axiosInstance.post("/saveContactUs",payload);
    return response.data;
  } catch (error) {
    console.error("saveContactUs API Error:", error);
    throw error;
  }
};
export const getFaq = async (payload) => {
  try {
    const response = await axiosInstance.post("/getFaq",payload);
    return response.data;
  } catch (error) {
    console.error("getFaq API Error:", error);
    throw error;
  }
};
export const getPodcasts = async (payload) => {
  try {
    const response = await axiosInstance.post("/getPodcasts",payload);
    return response.data;
  } catch (error) {
    console.error("getPodcasts API Error:", error);
    throw error;
  }
};
export const savePodcast = async (payload) => {
  try {
    const response = await axiosInstance.post("/savePodcast",payload);
    return response.data;
  } catch (error) {
    console.error("savePodcast API Error:", error);
    throw error;
  }
};
export const getPageContents = async (payload) => {
  try {
    const response = await axiosInstance.post("/getPageContents",payload);
    return response.data;
  } catch (error) {
    console.error("getPageContents API Error:", error);
    throw error;
  }
};

export const getUserNotifications = async (payload) => {
  try {
    const response = await axiosInstance.post("/getUserNotifications",payload);
    return response.data;
  } catch (error) {
    console.error("getUserNotifications API Error:", error);
    throw error;
  }
};

export const deleteNotification = async (payload) => {
  try {
    const response = await axiosInstance.post("/deleteNotification",payload);
    return response.data;
  } catch (error) {
    console.error("deleteNotification API Error:", error);
    throw error;
  }
};

export const getUsersSearch = async (payload) => {
  try {
    const response = await axiosInstance.post("/searchByUser",payload);
    return response.data;
  } catch (error) {
    console.error("getUsersSearch API Error:", error);
    throw error;
  }
};

export const getSinglePostDetails = async (payload) => {
  try {
    const response = await axiosInstance.post("/getSinglePostDetails",payload);
    return response.data;
  } catch (error) {
    console.error("getSinglePostDetails API Error:", error);
    throw error;
  }
};














